/**
 * Velora Modern keymap. Velora's own keys are bound where they are today
 * (shell bindings, manifest shortcuts, `useShortcut` in screens), so this
 * list only holds verbs that moved to the action registry. Owner: WP0-SHELL.
 */
import type { Keymap } from '../../skins/types.js';

export const keymap: Keymap = [];
